import { Translation } from '@ps/web-shared-components';
import React from 'react';

import SatIcon from '../../../assets/SatIcon.svg';
import TilesList from '../../TilesList/TilesList';

import {
  TXTCLI_Satellites_to_this_event_are_n_ELL,
  TXTCLI_Win_a_ticket_for_the_next_Sund_ELL
} from './NoSatellites.messages.json';
import styles from './NoSatellites.scss';

const NoSatellites: React.FC = () => (
  <div className={styles.root}>
    <div className={styles.header}>
      <SatIcon height={105} width={155} />
      <div className={styles.textContainer}>
        <Translation tagName="h2" {...TXTCLI_Satellites_to_this_event_are_n_ELL} />
        <hr />
        <Translation tagName="p" {...TXTCLI_Win_a_ticket_for_the_next_Sund_ELL} />
      </div>
    </div>
    <div>
      <TilesList direction="row" rect />
    </div>
  </div>
);

export default NoSatellites;
